import { defineComponent as _defineComponent } from 'vue'
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import CcSwitch from '@/views/Automation/CampaignCreatorV2/components/CcSwitch/CcSwitch.ts.vue';
import { Icons } from '@/views/Automation/CampaignCreatorV2/types';

interface Props {
  id: string;
  name: string;
  active: boolean;
  selected?: boolean;
  disableStatusChange?: boolean;
  icon?: Icons;
}

interface Emits {
  (e: 'changeStatus', value: boolean): void;
  (e: 'click'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CcPreviewCardSmall.ts',
  props: {
    id: null,
    name: { default: 'Campaign Name' },
    active: { type: Boolean },
    selected: { type: Boolean, default: false },
    disableStatusChange: { type: Boolean },
    icon: { default: 'speaker' }
  },
  emits: ["changeStatus", "click"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'changeStatus', value: boolean): void;
  (e: 'click'): void;
}), expose: any, slots: any, attrs: any }) {





function togglePreviewCard(value: boolean) {
  emits('changeStatus', value);
}

return { __sfc: true,emits, togglePreviewCard, CcIcon, CcSwitch }
}

})